import React from 'react';
import './VisageSidebarLines.scss';
import { ReactSVG } from 'react-svg';

interface IProps {
    items: any[];
}

const itemHeight = 34;

const getChildrenHeight = (item: any) => {
    if (!item.isExpanded) {
        return 0;
    }

    let height = 0;

    for (let child of (item.children || [])) {
        height += itemHeight;

        if (child.isExpanded) {
            height += getChildrenHeight(child);
        }
    }

    return height;
}

const getTotalHeight = (item: any) => {
    let height = itemHeight;

    if (item.isExpanded) {
        height += getChildrenHeight(item);
    }

    return height;
}

const VisageSidebarLines = (props: IProps) => {
    return null;
}

export default VisageSidebarLines;